import { render } from "./FinancialAccount.vue?vue&type=template&id=2ca689bc"
import script from "./FinancialAccount.vue?vue&type=script&lang=js"
export * from "./FinancialAccount.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__